import React from "react";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import dayjs from "../../../../../util/dayjs-config";
import AuditTrailComment from "../../tasks-audit-trail-comment/tasks-audit-trail-comment";
import ReadCountIcon from "../../../../../assets/icons/Icon-Eye-16px-Grey.svg";
import "./CommentTableRowNew.scss";

const CommentTableRowNew = ({
  comment,
  commentIndex,
  index,
  dateFormatID,
  viewFiles,
  onDownloadingFiles,
  clipped,
  setFilesList,
  setCurrComment,
  setDocumentLst,
  docuType,
  setFormModal,
  labels
}) => {
  const viewComment = (index, comment) => {
    clipped(index);
    setFilesList(true);
    setCurrComment(comment);
  };
  
  const openForm = (ev, formdata, comment) => {
    ev.preventDefault();
    let obj = {
      formdata: formdata,
      CreatedBy: comment.CreatedBy,
      Comment : comment
    }
    setFormModal(obj);
  }

  const FormView = (comment) => {
    try {
      let formdata = JSON.parse(comment.Note);
      return (
      <td className="left-aligned comment-comment-column" onClick={(e) => openForm(e, formdata, comment)}>
        <span className="ViewForm">View &lsquo;{formdata?.Label}&rsquo; {labels?.FormSingular ?? "Form"}</span>
      </td>
      )
    }
    catch (e) {
      return (
        <td className="left-aligned comment-comment-column">
          <span className="ViewForm">View {labels?.FormSingular ?? "Form"}</span>
        </td>
      )
    }
  }

  const FormatAction = (action) => {
    if (labels) {
      if (labels.ProjectSingular) {
        action = action.replaceAll("Project", labels.ProjectSingular);
      }
      if (labels.TaskSingular) {
        action = action.replaceAll("Task", labels.TaskSingular);
      }
      if (labels.FormSingular) {
        action = action.replaceAll("Form", labels.FormSingular);
      }
    }
    return action;
  }

  return (
    <tr>
      {/* Comment column */}
      {
     
        (comment.ActionId == 18 || comment.ActionId == 19)
          ?
          FormView(comment)
          :
          <td
            className="left-aligned comment-comment-column comment-hover"
            onClick={(e) => {
              comment?.Files?.length !== 0
                ? viewFiles(comment)
                : viewComment(index, comment);
            }}
          >
            {/* Comment display logic */}
            {comment.Note.substring(0, 1) === "<" || comment.Note === "" ? (
              <AuditTrailComment comment={comment.Note} index={index} />
            ) : (
              <OverlayTrigger
                placement="right"
                delay={{ show: 150, hide: 150 }}
                trigger={["hover", "focus"]}
                overlay={
                  <Tooltip className="task-tooltip" id={`tooltip-${index}`}>
                    {comment.Note}
                  </Tooltip>
                }
              >
                <div className="comment-short">{comment.Note}</div>
              </OverlayTrigger>
            )}
          </td>
      }

      {/* User column */}
      <td className="left-aligned user-comment-column">
        <div className="comment-user-container">
          {comment.ExternalEmail || comment.CreatedBy ? (
            <OverlayTrigger
              placement="right"
              delay={{ show: 150, hide: 150 }}
              trigger={["hover", "focus"]}
              overlay={
                <Tooltip className="task-tooltip" id={`tooltip-user-${index}`}>
                  {comment.ExternalEmail ?? comment.CreatedBy?.Name}
                </Tooltip>
              }
            >
              <div className="comment-username userName">
                {comment.ExternalEmail ?? comment.CreatedBy?.Name.length > 17
                  ? `${comment.ExternalEmail ?? comment.CreatedBy?.Name.slice(0, 15)}...`
                  : comment.ExternalEmail ?? comment.CreatedBy?.Name}
              </div>
            </OverlayTrigger>
          ) : (
            <div className="comment-username userName">{"Unknown User"}</div>
          )}
        </div>
      </td>

      {/* Date/Time column */}
      <td className="left-aligned comment-text-style date-comment-column">
        <OverlayTrigger
          placement="right"
          delay={{ show: 150, hide: 150 }}
          trigger={["hover", "focus"]}
          overlay={
            <Tooltip id={`tooltip-date-${index}`}>
              {comment?.Created && dayjs(comment.Created).format("MM/DD/YYYY")}
              &nbsp;&nbsp;
              {comment?.Created && dayjs(comment.Created).format("h:mm a")}
            </Tooltip>
          }
        >
          <div>
            {new Date(comment.Created).toLocaleDateString(dateFormatID)}
          </div>
        </OverlayTrigger>
      </td>

      {/* Action column */}
      <td className="left-aligned action-comment-column">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>{FormatAction(comment.Action)}</Tooltip>}
        >
          <div className="taskAuditStatusContainer">
            <div className="taskAuditStatusSpan">{FormatAction(comment.Action)}</div>
            {comment.ReadCount > 0 && (
              <div className="taskAuditStatusEmailReads">
                <img src={ReadCountIcon} alt="ReadCountIcon" />
                <span className="emailReadCounter">
                  {comment.ReadCount}
                </span>
              </div>
            )}
          </div>
        </OverlayTrigger>
      </td>

      {/* Attachments column */}
      <td className="center-aligned comment-action-column attachment-comment-column">
                <div className="comment-action-container">
                    {(comment.Files != null && comment.Files.length !== 0) ||
                    docuType === 3 ? (
                        <React.Fragment>
                            <div
                                className="btn-icon-container"
                                onClick={(e) => {
                                    viewFiles(comment);
                                }}
                            >
                                <div className="btn-icon view-file-icon"></div>
                            </div>
                            <div
                                className="btn-icon-container"
                                onClick={(e) => {
                                    onDownloadingFiles(comment.Files, comment);
                                }}
                            >
                                <div className="btn-icon download-file-icon"></div>
                            </div>
                        </React.Fragment>
                    ) : (commentIndex.includes(index) || comment?.ActionId == 13) ? (
                        <React.Fragment>
                            <div
                                className="btn-icon-container"
                                onClick={(e) => {
                                    setFilesList(true);
                                    setCurrComment(comment);
                                    // setDocumentLst(comment.Files);
                                }}
                            >
                                <div className="btn-icon view-file-icon"></div>
                            </div>
                            <div
                                className="btn-icon-container"
                                title="No files associated to this comment"
                            >
                                <div className="btn-icon download-grey"></div>
                            </div>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <div
                                className="btn-icon-container"
                                title="No files associated to this comment"
                            >
                                <div className="btn-icon view-grey"></div>
                            </div>
                            <div
                                className="btn-icon-container"
                                title="No files associated to this comment"
                            >
                                <div className="btn-icon download-grey"></div>
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </td>
    </tr>
  );
};

CommentTableRowNew.propTypes = {
  comment: PropTypes.object,
  commentIndex: PropTypes.array,
  index: PropTypes.number,
  dateFormatID: PropTypes.string,
  viewFiles: PropTypes.func,
  onDownloadingFiles: PropTypes.func,
  clipped: PropTypes.func,
  setFilesList: PropTypes.func,
  setCurrComment: PropTypes.func,
  setDocumentLst: PropTypes.func,
  docuType: PropTypes.number,
};

export default CommentTableRowNew;
